// User-facing copy: invites. Moved from the web app (pages/Join.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** pages/Join.tsx */
export const join = {
    everyWeek: "every week",
    everyTwoWeeks: "every two weeks",
    everyThreeWeeks: "every three weeks",
    everyMonth: "every month",
    everyWeeks: (round) => `every ${round} weeks`,
    checkingYourInvite: "Checking your invite",
    thisInviteIsNo: "This invite is no longer valid",
    goToYourClubs: "Go to your clubs",
    whatIsPagemates: "What is Pagemates?",
    askWhoeverSentIt: "Ask whoever sent it for a new one.",
    thisLinkHasExpired: "This link has expired",
    thisLinkWasTurned: "This link was turned off",
    thisLinkWasAlready: "This link was already used",
    invitesLastAWhile: "Invites last a while, not forever. Ask whoever sent it for a fresh one; it takes them ten seconds.",
    joining: "Joining…",
    joinAs: (name) => `Join as ${name}`,
    signedInAs: "Signed in as ",
    notYou: " · not you? ",
    signOut: "sign out",
    continueWith: "Continue with",
    readingNow: "Reading now",
    pages: (pages) => ` · ${pages} pages`,
    started: (day) => `Started ${day}`,
    theShelfSoFar: "The shelf so far",
    book: "book",
    books: "books",
    since: (sinceYear) => ` since ${sinceYear}`,
    justGettingStarted: "Just getting started",
    noBookOnThe: "No book on the shelf yet. You'll help pick the first one.",
    seeWhereEveryoneIs: "See where everyone is",
    inTheBookWithout: " in the book, without anyone having to say.",
    talkAsYouRead: "Talk as you read.",
    messagesPastYourSpot: " Messages past your spot stay sealed until you get there.",
    meetWithAnAgenda: "Meet with an agenda",
    theClubBuildsOn: " the club builds on the way: questions, flagged passages, your notes.",
    howThisClubWorks: "How this club works",
    youWereInvitedTo: "You were invited to",
    youReInvitedTo: "You're invited to",
    sentYouThis: " sent you this · ",
    member: "member",
    members: "members",
    justGettingStarted2: " · just getting started",
    members2: "Members",
    pace: "Pace",
    meets: "Meets",
    nextBook: "Next book",
    theOrganizerPicks: "the organizer picks",
    pickedByVote: "picked by vote",
    membersTakeTurns: "members take turns",
    spoilers: "Spoilers",
    sealedByWhereYou: "sealed by where you are",
    noSealingReadAt: "no sealing, read at your own risk",
    meeting: (day) => `meeting ${day}`,
    aboutPagesADay: (usualPace) => `about ${usualPace} pages a day`,
    next: (day) => `next ${day}`,
};
//# sourceMappingURL=invites.js.map